import {
  GET_ANALYTICS_STATS_START,
  GET_ANALYTICS_STATS_SUCCESS,
  GET_ANALYTICS_STATS_ERROR,
} from '../../actions/analytics/analytics.action';

const initialState = {
  stats: {
    overview: {
      piece_count: 0,
      paid_piece_count: 0,
    },
    piece_subscriptions: {
      labels: [],
      data: [],
    },
    user_subscriptions: {
      labels: [],
      data: [],
    },
  },
  isFetching: false,
  error: null,
};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ANALYTICS_STATS_START:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case GET_ANALYTICS_STATS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        stats: action.payload,
        error: null,
      };

    case GET_ANALYTICS_STATS_ERROR:
      return {
        ...state,
        isFetching: false,
        error: 'Failed to fetch analytics stats',
      };

    default:
      return state;
  }
};

export default analyticsReducer;
